import { useEffect } from "react";
import { useQuery } from "react-query";
import API from "utils/API";

const fetchDetails = () => {
  return API.get("GWConfig/ThirdPartyAdmin/list", {
    hasDefaultURL: true,
  });
};

const  useThirdPartyAdmin= () => {
  return useQuery("Thirdparty-admin", fetchDetails, {
    enabled: false
  });
};

export default useThirdPartyAdmin;